import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormLongAnswerBlock as Block } from "./FormLongAnswerBlock";
import { defaultData } from "./FormLongAnswerBlockDefaultData";
import { meta } from "./FormLongAnswerBlockMetaData";

export const FormLongAnswerBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-long-answer",
    size: 24,
  },
  meta,
};
